export const colFormRef = 'col-form-ref';
export const colFieldRef = 'col-field-ref';
export const colFileDropzone = 'col-file-dropzone';
